/*
 * SashiDo
 * All rights reserved.
 */

import SashiDoLogo from 'components/SashiDoLogo/SashiDoLogo.react';
import history from 'dashboard/history';
import GoogleTagManager from 'lib/GoogleTagManager';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import Button from 'components/Button/Button.react';
import Icon from 'components/Icon/Icon.react';
import Popover from 'components/Popover/Popover.react';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import ParseApp from 'lib/ParseApp';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './CreateApp.scss';
import TextInput from 'components/TextInput/TextInput.react';
import Dropzone from 'react-dropzone';
import AppsManager from 'lib/AppsManager';
import { getBase64ImageFromUrl } from 'lib/helpers';
import Notification from 'components/Notification/Notification.react';

// import ShowAppPrice         from 'dashboard/Billing/ShowAppPrice.react';

import {
  regionsList,
  availableRegions,
} from 'lib/Constants';

export default class CreateApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appName: '',
      appRegion: '',
      error: false,
      files: false,
      showLoadingDots: false,
    };


    this.LatestParseServerVersion = props.availableParseServerVersions.find((v => v.latest)).imageTag;

    // TODO: @pivanov - uncomment when you finish with refactoring
    // if(this.props.currentCustomer.is_trial && !this.props.currentCustomer.has_payment_method) {
    if (!props.currentCustomer.is_trial && !props.currentCustomer.has_payment_method) {
      history.push('/billing/add_card');
    }

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    Intercom('trackEvent', 'open_app_create');
    document.body.addEventListener('keydown', this.handleKey);

    const { subscription } = this.props.currentCustomer;
    const { status: subscriptionStatus } = subscription;

    GoogleTagManager({
      data: {
        event: 'impressions',
        pageCategory: 'new-app',
        subscriptionStatus,
        currencyCode: 'USD',
      },
    });
  }

  onCloseClick() {
    Intercom('trackEvent', 'close_app_create');
    window.location = '/products/apps';
  }

  onCreateClick = async () => {
    this.setState({
      showLoadingDots: true,
    });

    document.body.removeEventListener('keydown', this.handleKey);

    const { files } = this.state;
    const blob = files ? files[0].preview : null;
    let icon;

    if (blob) {
      icon = await getBase64ImageFromUrl(blob);
    }


    AppsManager.create({
      name: this.state.appName,
      region: this.state.appRegion,
      icon,
      parseServerVersion: this.LatestParseServerVersion,
    }).then(({ app }) => {
      window.location = (`/products/apps/${app.slug}/creation`);
    }).catch((error) => {
      this.setState({ showLoadingDots: false, error: error.message, note: null });
    });
  }

  onDrop = (files) => {
    if (files[0].size > 200000) {
      this.setState({
        note: {
          type: 'error',
          message: 'This file is bigger than 200k',
        },
      });
      return null;
    }

    this.setState({ files, note: null });
  }

  onInputChange(appName) {
    const isInvalid = !this.valid(appName);

    this.setState({
      appName,
      warning: !!isInvalid,
      note: null,
    });
  }

  onOpenClick() {
    this.refs.dropzone.open();
  }

  handleGoBack() {
    document.body.addEventListener('keydown', this.handleKey);

    this.setState({
      error: false,
    });
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  valid(string) {
    return string.length >= 1 && string.match(/^[\s0-9a-zA-Z._-]+$/);
  }


  renderCreateAppView = () => {
    const {
      files,
      appName,
      appRegion,
      note,
      warning,
    } = this.state;

    const file = files[0];

    const disableCreateButton = (appName === '' && appRegion === '');

    return (
      <div>
        <div className={styles.holder}>
          <div className={styles.content}>
            <h1>It's time to create amazing things!</h1>

            <Dropzone ref="dropzone" onDrop={this.onDrop} style={{}} accept="image/*" className={styles.dropzone} activeClassName={styles.dropzoneActive}>
              <div className={[styles.appIconHolder, file ? styles.uploaded : null].join(' ')}>
                <Icon width={200} height={200} name="icon-dashed-icon" colored />
                {
                  file
                    ? <img src={file.preview} key={file.name} />
                    : <span>Upload / Drop App Icon<br /><span>max 200kb</span></span>
                }
                <Notification note={note} fullscreen />
              </div>
            </Dropzone>

            <TextInput placeholder="Pick a good name ..." width={350} theme="dark" maxLength="24" value={appName} onChange={this.onInputChange.bind(this)} />

            <span className={[styles.warningMessage, warning ? styles.warning : null].join(' ')}>* Name have to be at least 1 character. Only letters (a-z), numbers (0-9), and periods (.) are allowed.</span>

            <div style={{ marginTop: '60px' }}>
              <ChromeDropdown
                value={appRegion}
                width="288px"
                className="migration"
                options={regionsList}
                available={availableRegions}
                placeholder="Choose your app region ..."
                onChange={appRegion => this.setState({ appRegion, note: null })} />
            </div>

            <div className={[styles.buttonHolder, styles.show].join(' ')}>
              <Button value="Create" color="green" size="big" block disabled={disableCreateButton} theme="dark" onClick={this.onCreateClick} />
            </div>
            {
              // TODO: @pivanov - for some reason following component not work for a long time
              // this.state.appRegion
              //   ? <ShowAppPrice region={this.state.appRegion} {...this.props} />
              //   : null
            }
          </div>
        </div>
      </div>
    );
  };

  render() {
    const CancelIcon =
      !this.state.showLoadingDots
        ? (
          <a href="javascript:;" className={styles.iconClose} onClick={this.onCloseClick.bind(this)} >
            <Icon width={16} height={16} name="icon-close" />
          </a>
        )
        : null;

    const loadingDots = (
      <div className={styles.loading}>
        <div>
          <h1>Create Application</h1>
          <LoaderDots />
        </div>
      </div>
    );

    const errorMessageView = (
      <div className={[styles.holder, styles.center].join(' ')}>
        <p className={styles.error}>{this.state.error}</p>
        <div className={[styles.buttonHolder, styles.show].join(' ')}>
          <Button value="Go Back" color="green" block theme="dark" onClick={this.handleGoBack.bind(this)} />
        </div>
      </div>
    );

    return (
      <Popover modal onExternalClick={() => this.setState({ open: true })}>
        <div className={styles.appCreate}>
          <div className={styles.showEffect} />
          {this.state.error ? errorMessageView : null}
          { this.state.showLoadingDots
            ?
              !this.state.error ? loadingDots : null
            :
              !this.state.error ? this.renderCreateAppView() : null
          }
          <SashiDoLogo />
          {!this.state.error ? CancelIcon : null}
        </div>
      </Popover>
    );
  }
}

CreateApp.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
